@let gamesList = games(); @let count = gamesCount();

<div class="or-pb-8-px games-list__head">
  <lib-filters [showGameVisibilityFilter]="true"></lib-filters>
  @if (gamesList?.ignoredLocationFilter) {
    <div class="or-mx-16-px or-mt-8-px or-text-sm or-color-secondary-2">
      Brak gierek w tym obszarze. Filtr odległości został zignorowany.
    </div>
  }
</div>

<div class="games-list__scroll">
  @if (isAdmin()) {
    <div class="or-align-items-center or-d-flex or-justify-content-between or-mx-16-px">
      <div class="or-text-md">Pokaż prywatne gierki ({{ count?.totalGames }}/{{ count?.privateGames }})</div>
      <ion-toggle [checked]="false" (ionChange)="setShowPrivateGames($event.detail.checked)"> </ion-toggle>
    </div>
  }
  @for (group of gamesList?.day; track group.date; let first = $first, dayIndex = $index) {
    <div class="or-head-md or-color-secondary-2 or-pl-20-px" [ngClass]="first ? 'or-mt-8-px' : 'or-mt-24-px'">
      {{ group.date }}
    </div>
    @for (game of group.games; track game.gameId; let gameIndex = $index) {
      <div class="or-my-12-px">
        <lib-game-card-v2
          (click)="openDetailsModal(game); $event.stopPropagation()"
          [game]="game"
          [showHostDetails]="true"
          [isAdmin]="isAdmin() ?? false"
          [badgeMode]="badgeMode.PLAYER"></lib-game-card-v2>
      </div>

      @if (isLocationBoxPosition(dayIndex, gameIndex)) {
        <div class="or-mx-16-px or-my-12-px">
          <lib-location-info-box
            (clicked)="onLocationBoxClicked()"
            (locationAcquired)="onLocationAcquired($event)"></lib-location-info-box>
        </div>
      }
    }
  }
  @if (!count?.totalGames) {
    <div class="or-head-sm or-px-20-px or-d-flex or-text-align-center or-align-items-center empty-state-height">
      Brak dopasowanych gierek. Zmień lub wyczyść filtry aby zobaczyć więcej.
    </div>
  }
</div>
